export default __webpack_public_path__ + "static/media/Vrindhavan Jewels.9373cd0b.PNG";